<ng-template [vbCssRules]="themeStyleOverrides">
</ng-template>
<nav class="theme-header-bg" role="navigation">

	<section class="navbar-wrapper">
		<section class="navbar" layout="row" flex-wrap="false">

			<mobile-menu flex="2" [hidden]="isRegisteredGuest" flex-gt-md="hide" [theme]="currentTheme" [headerSettings]="headerSettings" [themeSettings]="themeSettings" [isAnalystAdmin]="isAnalystAdmin" [showManageSubscriptions]="showManageSubscriptions" [landingState]="landingState" [isGuestMode]="isGuestMode">
			</mobile-menu>

			<div class="brand-cell logo-section" flex="33" flex-align-self="start">
				<a uiSref="void" class="skip-link" (click)="skipNavigation()">{{ 'SkipToMainContent' | translate }}</a>
				<a [attr.aria-label]="('Application_CompanyLogo' | translate) + ' - ' + ('Home' | translate)" class="theme-logo margin-0 padding-0" href="#/" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']">
					<branding-logo></branding-logo>
				</a>
				<div *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true">
					@if (guestPortalRestricted) {
						<span class="d-block margin-0 padding-0">
							<branding-logo></branding-logo>
						</span>
					}@else {
						<a [attr.aria-label]="('Application_CompanyLogo' | translate) + ' - ' + ('Home' | translate)" [href]="isGuestMode ? '#/' : '/guest'" class="d-block margin-0 padding-0" [tabindex]="0">
							<branding-logo></branding-logo>
						</a>
					}
				</div>
			</div>

			<div *vbAuthorizationKey="'distribution.authenticated'; fallback true" class="search-cell" flex="33" flex-align-self="center" role="search">
				<search-header *ngIf="!guestPortalRestricted" class="twoTier-search-header">
				</search-header>
			</div>

			<div class="margin-right-30 xs-mbl-left-30 right-container" layout="row" flex="33" flex-align="center" flex-justify="end">
					
				@if(enableCapture) {
					<a href="/capture" target="capture" class="flex-center-align admin-btn utility-section text-color-inherit main-nav-btn line-height-1 text-decoration-none" *vbAuthorizationKey="'media.add'" [title]="'Capture_ScreenRecorder' | translate" [attr.aria-label]="'Capture_ScreenRecorder' | translate">
						<span class="vb-icon vb-icon-capture"></span>
					</a>
				}

				<go-live [bgNone]="true" [iconCssClass]="'theme-header-txt'" [dropdownCssClass]="'align-right'">
				</go-live>

				<div class="dropdown upload-cell align-right" dropdown vbDropdown #headerUploadMenuDropdown="bs-dropdown" [insideClick]="true" *vbAuthorizationKey="'media.add'">
					<button [attr.aria-label]="('Upload' | translate) + ' - ' + ('UI_Menu' | translate)" class="dropdown-toggle btn main-nav-btn upload bg-none" dropdownToggle>
						<span class="vb-icon vb-icon-center vb-icon-upload">
						</span>
					</button>
					<div class="dropdown-menu dropdown-menu-right upload-media" *dropdownMenu>
						<upload-menu (onCloseUploadMenu)="headerUploadMenuDropdown.hide()">
						</upload-menu>
					</div>
				</div>
				<notifications-menu-button class="notification-cell count-bubble" *ngIf="isUserAuthenticated" [alwaysShowIcon]="true">
				</notifications-menu-button>
			</div>
		</section>
	</section>

	<section class="navbar-tier-two" layout="row" flex-align="center" flex-wrap="false">
		<div flex="1" flex-justify="center">
			<ul class="menu-list-tight">
				<li class="margin-right-30 box-inline-block media-menu-list-item" *vbAuthorizationKey="'authenticated'">
					<media-menu-dropdown class="type-13" [currentTheme]="currentTheme">
					</media-menu-dropdown>
				</li>

				@if (isGuestMode) {
					<li class="margin-right-30 box-inline-block" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true">
						<a class="theme-header-txt util-no-underline type-13 padding-top-2" *vbAuthorizationKey="['guest']" [uiSref]="PORTAL_MEDIA_ALL_STATE" data-toggle="tab" uiSrefActive="active">
							{{ 'Media_AllVideos' | translate }}
						</a>
					</li>

					@if (enableCategories) {
						<li class="margin-right-30 box-inline-block" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true">
							<a class="theme-header-txt util-no-underline type-13 padding-top-2" *vbAuthorizationKey="['guest']" [uiSref]="PORTAL_MEDIA_BROWSE_STATE" data-toggle="tab" uiSrefActive="active">
								{{ 'Media_Categories' | translate }}
							</a>
						</li>
					}
				}
									
				@if (!isGuestMode || enablePublicWebcastAccess) {
					<li class="margin-right-30 box-inline-block" *vbAuthorizationKey="['authenticated', 'distribution.authenticated', isGuestMode ? 'guest' : '']">
						<a class="theme-header-txt util-no-underline type-13 padding-top-2" [uiSref]="CALENDAR_STATE_NAME" [uiOptions]="{reload: true, inherit: false}" data-toggle="tab" uiSrefActive="active">
							{{ 'Events' | translate }}
						</a>
					</li>
				}
				
				<li class="margin-right-30 box-inline-block" *vbAuthorizeState="'portal.admin'">
					<a class="theme-header-txt util-no-underline type-13" uiSref="portal.load-admin" [uiParams]="{accountId: accountId}" data-toggle="tab">
						{{ (isAnalystAdmin ? 'Analytics' : 'Admin') | translate }}
					</a>
				</li>
				<ng-container *ngIf="!account.readonlyUserProfile">
					<li class="box-inline-block" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']">
						<a class="theme-header-txt util-no-underline type-13" uiSref="portal.userProfile" data-toggle="tab">
							{{ 'UserProfile_MyProfile' | translate }}
						</a>
					</li>
				</ng-container>
				<ng-container *ngIf="showManageSubscriptions">
					<li *vbAuthorizationKey="['authenticated']" class="margin-left-30 margin-bottom-2 box-inline-block">
						<a class="theme-header-txt util-no-underline type-13" [uiSref]="'portal.manageSubscriptions'">
							{{ 'ManageSubscriptions' | translate }}
						</a>
					</li>
				</ng-container>
			</ul>
		</div>

		<!-- Event Title -->
		<div class="event-title-container" [hidden]="!event" flex="1">
			<a class="event-display theme-header-txt type-13" flex-justify="end" *vbAuthorizationKey="'authenticated'" uiSref="portal.scheduledEvents.webcast" [uiParams]="{webcastId: event?.id}">
				<p class="event-display-text">{{ event?.startDate | vbDateTimeMedium }}</p>
				<span>&nbsp;-&nbsp;</span>
				<p class="event-display-text event-display-link">{{ event?.title }}</p>
			</a>
		</div>

		<div flex="1">
			<ul class="menu-list-tight margin-right-30" layout="row" flex-align="baseline" flex-justify="end">
				<!-- Username -->
				<li class="theme-header-txt text-hover-none box-inline-block type-13" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']">
					<vb-profile-picture [altTxt]="'UserProfile_ProfilePicture' | translate" [profileUrl]="user.profileImageUri">
					</vb-profile-picture>
					{{ user.fullName | slice:0:30 }}
				</li>
				<li class="box-inline-block margin-left-30 logout-help-container">
					<!-- Login (unauthenticated) -->
					<a class="theme-accent-link type-13" flex="hide" flex-gt-md (click)="loginRedirect()" [hidden]="isRegisteredGuest" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true">
						<span class="vb-icon vb-icon-user-circle margin-right-3"></span>
						<span>{{ 'SignIn' | translate }}</span>
					</a>
					<!-- Logout -->
					<a class="theme-header-txt type-13" uiSref="logout" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']">
						{{ 'Logout' | translate }}
					</a>
					<help-menu class="type-13" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']">
					</help-menu>
				</li>
			</ul>
		</div>
	</section>

</nav>
